/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';

// material
import {
  Box,
  MenuItem,
  Typography,
  Container,
  Table,
  Card,
  Button,
  Grid,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  CardMedia,
  Divider,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Avatar,
  CircularProgress,
  LinearProgress,
  FormControl,
  InputLabel,
  Select,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { isoDateFormatInDmyhs } from '../utils/formatTime';
// components
import Page from '../components/Page';
import { useAuth } from '../components/customContextProviders/AuthContext';
import { GetAllOrganinazationUser } from '../network/Organization';
import {
  capitalizeFirstLetter,
  extractHierarchyInfoFromPath,
  getAdminRoleFromHierarchy,
  parseValidationErrorMessage,
  stringAvatar
} from '../utils/Utilities';
import { AddUserToOrganizationModal, DeviceOrderdButtons } from '../components/_dashboard/soundbox';
import { APP_CONSTANTS } from '../URLConstants';
import UserMoreMenu from '../components/_dashboard/soundbox/UserMoreMenu';
import { ConfirmDialog, NoDataAvailable } from '../components/_dashboard/app';
import { ActivateUser, DeActivateUser, DeleteUser } from '../network/User';
import DashboardNavbar from '../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../layouts/dashboard/DashboardSidebar';
import AddUserToNoxModal from '../components/_dashboard/soundbox/AddUserToNoxModal';
import { SnackBarAlert, CustomPagination } from '../components/HelperComponents';

// ----------------------------------------------------------------------

let currentPage = 1;
let isHasTransactionDataHasNextPage = true;

export default function OrganizationUsers() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [organizationUsers, setOrganizationUsers] = useState([]);
  const [filterType, setFilterType] = useState('username'); // default to 'name'
  const [filterValue, setFilterValue] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const {
    sessionUserData,
    fetchTaxonomyDetails,
    accountDetails,
    headOfficesList,
    zonesList,
    regionsList,
    branchesList,
    fetchRegionList,
    fetchZonesList,
    fetchBranchesList,
    fetchHeadOfficesList,
    userLoginOrg,
    isCheckerMakerRequired
  } = useAuth();

  const cardRef = useRef(null);
  const [isAddUserToNoxModalOpen, setIsAddUserToNoxModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [showUserDetails, setShowUserDetails] = useState('');
  const [dataShowMode, setDataShowMode] = useState('GRID');

  const [openConfirm, setOpenConfirm] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({
    loading: false,
    message: '',
    note: false,
    onConfirm: () => { },
    onCancel: () => setOpenConfirm(false),
    confirmText: 'Yes',
    cancelText: 'No'
  });

  const where = {
    ...(filterValue ? { [filterType]: filterValue } : {})
  };

  let logoImage;

  if (userLoginOrg === APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/bom-icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/cbi_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.IOB_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/iob_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.UJN_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/ujn_icon.svg';
  } else if (userLoginOrg === APP_CONSTANTS?.KAGB_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/kagb_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER) {
    logoImage = '';
  } else if (userLoginOrg === APP_CONSTANTS?.COSMOS_CLIENT_IDENTIFIER) {
    logoImage = '/assets/Cosmos/cosmos_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.PRATAP_CLIENT_IDENTIFIER) {
    // logoImage = '/assets/Pratap/pratap_icon.png';
    logoImage = '';
  } else if (userLoginOrg === APP_CONSTANTS?.RSB_CLIENT_IDENTIFIER) {
    logoImage = '/assets/RSB/rsbIcon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.GBCB_CLIENT_IDENTIFIER) {
    logoImage = '/assets/GBCB/gbcbicon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.HASTI_CLIENT_IDENTIFIER) {
    logoImage = '/assets/HASTI/hasti-icon.png';
  }
  else {
    logoImage = process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ICON;
  }
  useEffect(() => {
    fetchOrganizationUser(page, where, 'SEARCH');
    if (sessionUserData?.user?.taxonomyId) {
      fetchTaxonomyDetails(sessionUserData?.user?.taxonomyId);
    }
    return () => {
      setOrganizationUsers([]);
      currentPage = 1;
      isHasTransactionDataHasNextPage = true;
    };
  }, []);

  function onAction() {
    fetchOrganizationUser(page, where, 'SEARCH');
  }
  const sessionUserPath = accountDetails?.path;

  const handleShowDataChangeVal = (event) => {
    setDataShowMode(event?.target?.value);
  };

  function fetchOrganizationUser(page, where, type) {
    setLoading(true);
    setOrganizationUsers([]);

    GetAllOrganinazationUser(page, 10, where)
      .then((res) => {
        isHasTransactionDataHasNextPage = res?.data?.hasNextPage;
        if (type === 'LOAD') setOrganizationUsers((prevList) => [...prevList, ...res?.data?.data]);
        else if (type === 'SEARCH') {
          setOrganizationUsers([]);
          setOrganizationUsers(res?.data?.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function handleDeactivateActivateUser(userData, status) {
    setDialogConfig((prevState) => ({
      ...prevState,
      loading: true
    }));

    if (status === 'deactivate') {
      DeActivateUser(userData?.id, false)
        .then((res) => {
          setDialogConfig((prevState) => ({
            ...prevState,
            loading: false
          }));
          setOpenConfirm(false);
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: `Successfully de-activated ${userData?.name}!`,
            severity: 'success'
          }));
          setIsSnackBarAlertOpen(true);

          setPage(1);
          fetchOrganizationUser(1, where, 'SEARCH');
        })
        .catch((err) => {
          setDialogConfig((prevState) => ({
            ...prevState,
            loading: false
          }));
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: parseValidationErrorMessage(err),
            severity: 'error'
          }));
          setIsSnackBarAlertOpen(true);
        });
    } else if (status === 'activate') {
      ActivateUser(userData?.id, true)
        .then((res) => {
          setDialogConfig((prevState) => ({
            ...prevState,
            loading: false
          }));
          setOpenConfirm(false);

          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: `Successfully Activated ${userData?.name}!`,
            severity: 'success'
          }));
          setIsSnackBarAlertOpen(true);

          setPage(1);
          fetchOrganizationUser(1, where, 'SEARCH');
        })
        .catch((err) => {
          setDialogConfig((prevState) => ({
            ...prevState,
            loading: false
          }));
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: parseValidationErrorMessage(err),
            severity: 'error'
          }));
          setIsSnackBarAlertOpen(true);
        });
    }
  }

  function deleteUser(userId) {
    setDialogConfig((prevState) => ({
      ...prevState,
      loading: true
    }));

    DeleteUser(userId)
      .then((res) => {
        setDialogConfig((prevState) => ({
          ...prevState,
          loading: false
        }));
        setOpenConfirm(false);
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: `Successfully deleted!`,
          severity: 'success'
        }));
        setIsSnackBarAlertOpen(true);

        setPage(1);
        fetchOrganizationUser(1, where, 'SEARCH');
      })
      .catch((err) => {
        setDialogConfig((prevState) => ({
          ...prevState,
          loading: false
        }));
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(err),
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
      });
  }

  const handleUserMoreMenuClick = (action, userData) => {
    switch (action) {
      case 'activate': {
        setDialogConfig({
          ...dialogConfig,
          loading: false,
          message: 'Are you sure want to activate this User?',
          title: 'Activate',
          onConfirm: () => handleDeactivateActivateUser(userData, 'activate'),
          onCancel: () => setOpenConfirm(false),
          confirmText: 'Yes',
          cancelText: 'No'
        });
        setOpenConfirm(true);
        break;
      }
      case 'deactivate': {
        setDialogConfig({
          ...dialogConfig,
          loading: false,
          message: 'Are you sure want to De-activate this User?',
          title: 'De-Activate',
          onConfirm: () => handleDeactivateActivateUser(userData, 'deactivate'),
          onCancel: () => setOpenConfirm(false),
          confirmText: 'Yes',
          cancelText: 'No'
        });
        setOpenConfirm(true);
        break;
      }
      case 'delete-user': {
        setDialogConfig({
          ...dialogConfig,
          loading: false,
          message: 'Are you sure want to Delete this User?',
          title: 'Delete',
          onConfirm: () => deleteUser(userData?.id),
          onCancel: () => setOpenConfirm(false),
          confirmText: 'Yes',
          cancelText: 'No'
        });
        setOpenConfirm(true);
        break;
      }
      case 'edit-user': {
        setIsAddUserToNoxModalOpen(true);
        fetchHeadOfficesList();
        setSelectedUser(userData);
        break;
      }

      default: {
        return;
      }
    }
  };

  const handleChangePage = (data, customPage) => {
    let newPage = page;
    if (data === 'NEXT') newPage += 1;
    else newPage -= 1;

    if (customPage) {
      setPage(customPage);
      fetchOrganizationUser(customPage, where, 'SEARCH');

      return;
    }
    setPage(newPage);
    fetchOrganizationUser(newPage, where, 'SEARCH');
  };

  const triggerSearchCbi = (value) => {
    const enteredValue = value.trim();
    currentPage = 1;

    const searchParams = {};

    if (enteredValue) {
      if (filterType === 'deviceId') {
        searchParams.deviceId = enteredValue;
      } else if (filterType === 'accountNumber') {
        searchParams.accountNumber = enteredValue;
      } else if (filterType === 'name') {
        searchParams.name = enteredValue;
      } else if (filterType === 'phone') {
        searchParams.phone = enteredValue;
      } else if (filterType === 'username') {
        searchParams.username = enteredValue;
      }
    }
    setPage(1);
    fetchOrganizationUser(1, searchParams, 'SEARCH');
  };

  async function handleDownloadExcel() {
    setIsDownloadingExcel(true);
    try {
      const response = await GetAllOrganinazationUser(page, 10, where);
      const currentViewData = response?.data?.data || [];

      const worksheetData = currentViewData.map((user) => ({
        Name: user?.name || '',
        Phone: user?.phone || '',
        Email: user?.email || '',
        'Employee ID': user?.username || '',
        Role:
          user?.role?.toLowerCase() === 'admin'
            ? getAdminRoleFromHierarchy(user?.taxonomy?.path)
            : capitalizeFirstLetter(user?.role) || '',
        Status: user?.activated ? 'Active' : 'Inactive',
        'Onboarded Date': user?.createdAt ? isoDateFormatInDmyhs(user?.createdAt) : ''
      }));

      const ws = XLSX.utils.json_to_sheet(worksheetData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Users');
      XLSX.writeFile(wb, 'UsersCurrentView.xlsx');
    } catch (err) {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: 'Failed to download. Please try again.',
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    } finally {
      setIsDownloadingExcel(false);
    }
  }

  return (
    <Page title=" Users">
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Container maxWidth="false">
        <Stack
          direction={{ md: 'row', xs: 'column' }}
          spacing={{ md: 2, xs: 1 }}
          alignItems={{ md: 'center', xs: 'flex-start' }}
          justifyContent="space-between"
          sx={{ width: '100%' }}
          px={1}
        >
          <DeviceOrderdButtons
            onUserCreation={onAction}
            onDownloadExcel={handleDownloadExcel}
            isDownloadingExcel={isDownloadingExcel}
          />
          <Stack direction="row" spacing={2} alignItems="center">
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel id="search-by-label">Search By</InputLabel>
              <Select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                label="Search By"
                labelId="search-by-label"
                id="search-by-select"
              >
                <MenuItem value="name">User Name</MenuItem>
                <MenuItem value="username">Employee Id</MenuItem>
                <MenuItem value="phone">User Phone No.</MenuItem>
              </Select>
            </FormControl>

            <Typography> = </Typography>

            <TextField
              id="searchValueInput"
              data-testid="search-value-input"
              size="small"
              label="Enter Value"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              sx={{ width: 300 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      data-testid="search-icon-btn"
                      onClick={() => triggerSearchCbi(filterValue)}
                    >
                      <SearchOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  triggerSearchCbi(filterValue);
                }
              }}
            />

            <ToggleButtonGroup
              data-testid="view-toggle"
              color="primary"
              value={dataShowMode}
              exclusive
              aria-label="Platform"
              sx={{ height: '45px', pb: 1 }}
              onChange={handleShowDataChangeVal}
            >
              <ToggleButton value="GRID" data-testid="grid-btn">
                Grid
              </ToggleButton>
              <ToggleButton value="LIST" data-testid="list-btn">
                List
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Stack>

        {dataShowMode === 'LIST' ? (
          <Card sx={{ mt: 1 }}>
            <TableContainer
              data-testid="list-table"
              sx={{ maxHeight: '72vh', overflowY: 'scroll', minHeight: '72vh' }}
              ref={cardRef}
            >
              <Table sx={{ minWidth: 650 }} aria-label="merchant_table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      Name
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      Phone
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      Email
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      Role
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      Onboarded Date
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}>
                      User Status
                    </TableCell>
                    <TableCell align="left" sx={{ fontWeight: 900 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {organizationUsers.map((user) => (
                    <TableRow
                      key={user?.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        align="left"
                        sx={{ textTransform: 'capitalize' }}
                      >
                        {user?.name}
                      </TableCell>
                      <TableCell align="left">{user?.phone}</TableCell>
                      <TableCell align="left">{user?.email}</TableCell>
                      <TableCell align="left">
                        {user?.role?.toLowerCase() === 'admin'
                          ? getAdminRoleFromHierarchy(user?.taxonomy?.path)
                          : capitalizeFirstLetter(user?.role)}
                      </TableCell>
                      <TableCell align="left">{isoDateFormatInDmyhs(user?.createdAt)}</TableCell>
                      <TableCell align="left">
                        <Chip
                          label={user?.activated ? 'ACTIVE' : 'INACTIVE'}
                          sx={{
                            backgroundColor: user?.activated ? '#a2e1ac' : '#e1a2a2',
                            color: 'black',
                            fontWeight: 'bold'
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <UserMoreMenu
                          userData={user}
                          handleClicks={(e) => handleUserMoreMenuClick(e, user)}
                          userRole={
                            isCheckerMakerRequired === 'YES' &&
                              sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN
                              ? getAdminRoleFromHierarchy(sessionUserPath)
                              : sessionUserData?.user?.role
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {organizationUsers?.length === 0 && loading !== true && (
                    <TableRow>
                      <TableCell colSpan={10}>
                        <NoDataAvailable />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              {loading && <LinearProgress color="success" />} {/* LinearProgress for List */}
            </TableContainer>
            <Divider sx={{ m: 0 }} />

            <CustomPagination
              page={page}
              handleNextPage={() => handleChangePage('NEXT')}
              handlePreviousPage={handleChangePage}
              hasNextPage={isHasTransactionDataHasNextPage}
              data={organizationUsers}
              setPage={setPage}
            />
          </Card>
        ) : (
          <>
            <Grid
              container
              spacing={2}
              sx={{
                width: '100%',
                mt: 1,
                ml: 1,
                maxHeight: '72vh',
                overflowY: 'auto',
                minHeight: '72vh'
              }}
              data-testid="grid-cards"
              ref={cardRef}
            // onScroll={handleScroll}
            >
              {organizationUsers?.map((row, index) => (
                <Grid size={{ xs: 12, sm: 4, md: 3 }} mb={1}>
                  <Card sx={{ width: '100%', minHeight: 250 }}>
                    {userLoginOrg === APP_CONSTANTS?.PRATAP_CLIENT_IDENTIFIER ? (
                      <Box
                        aria-hidden
                        sx={{
                          height: 120,
                          width: '100%',
                          background: 'linear-gradient(to right,#fff 0%, #B95256 86%)'
                        }}
                      />
                    ) : (
                      <CardMedia
                        sx={{
                          height: 120,
                          backgroundColor: '#0275bf',
                          objectFit: 'contain',
                          opacity: 0.7
                        }}
                        height="140"
                        component="img"
                        src={logoImage}
                        alt=""
                        title={row?.name}
                      />
                    )}

                    <Box
                      data-testid="status_card"
                      sx={{ position: 'absolute', top: '30%', right: '5%' }}
                    >
                      <Avatar
                        data-testid={row?.activated ? 'user-active' : 'user-inactive'}
                        sx={{
                          width: 56,
                          height: 56,
                          backgroundColor: row?.activated
                            ? 'rgba(9, 180, 9, 0.25)' // richer green
                            : 'rgba(200, 40, 40, 0.25)' // richer red
                        }}
                      />
                    </Box>

                    {row?.role !== undefined && row?.role !== null && row?.role !== '' ? (
                      <Chip
                        variant="contained"
                        size="small"
                        label={
                          row?.role?.toLowerCase() === 'admin'
                            ? getAdminRoleFromHierarchy(row?.taxonomy?.path)
                            : capitalizeFirstLetter(row?.role)
                        }
                        sx={{
                          fontSize: '12px',
                          fontWeight: 700,
                          ml: 1,
                          position: 'absolute',
                          top: '2%',
                          background:
                            row?.role === 'admin'
                              ? 'linear-gradient(135deg, #00c6ff, #0072ff)'
                              : row?.role === 'checker'
                                ? 'linear-gradient(135deg, #CD6379, #ff5e62)'
                                : row?.role === 'maker'
                                  ? 'linear-gradient(135deg, #CD6379, #ff5e62)'
                                  : 'linear-gradient(135deg, #CD6379, #ff5e62)',
                          color: '#fff'
                        }}
                      />
                    ) : null}

                    <UserMoreMenu
                      sx={{
                        position: 'absolute',
                        top: '1%',
                        right: '0%',
                        fontWeight: 900,
                        color: 'black'
                      }}
                      userData={row}
                      handleClicks={(e) => handleUserMoreMenuClick(e, row)}
                      userRole={getAdminRoleFromHierarchy(sessionUserPath)}
                    />

                    {showUserDetails === index + 'show' ? (
                      <Box
                        sx={{
                          p: 2,
                          position: 'absolute',
                          top: '15%',
                          width: '100%',
                          height: '100%',
                          backgroundColor: '#F8FAFB'
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 700,
                            color: '#171D40',
                            textTransform: 'capitalize'
                          }}
                        >
                          {row?.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            lineHeight: '20px',
                            color: '#6F6F6F'
                          }}
                        >
                          Date Created - {isoDateFormatInDmyhs(row?.createdAt)}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            lineHeight: '20px',
                            color: '#6F6F6F'
                          }}
                        >
                          Email - {row?.email}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            lineHeight: '20px',
                            color: '#6F6F6F'
                          }}
                        >
                          Mobile - {row?.phone}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            lineHeight: '20px',
                            color: '#6F6F6F'
                          }}
                        >
                          {(() => {
                            const hierarchy = extractHierarchyInfoFromPath(row?.taxonomy?.path);
                            const adminRole = getAdminRoleFromHierarchy(row?.taxonomy?.path);

                            if (row?.role === APP_CONSTANTS?.USER_ROLE_ADMIN) {
                              switch (adminRole) {
                                case 'HOAdmin':
                                  return `Head Office - ${hierarchy.headOffice}`;
                                case 'ZOAdmin':
                                  return `Zone Office - ${hierarchy.zoneOffice}`;
                                case 'ROAdmin':
                                  return `Regional Office - ${hierarchy.regionalOffice}`;
                                default:
                                  return 'Admin';
                              }
                            }

                            if (
                              row?.role === APP_CONSTANTS?.USER_ROLE_MAKER ||
                              row?.role === APP_CONSTANTS?.USER_ROLE_CHECKER
                            ) {
                              return `BranchId - ${hierarchy.branchId}`;
                            }

                            return `Mobile - ${row?.phone}`;
                          })()}
                        </Typography>

                        <Button
                          size="small"
                          sx={{ mt: 2 }}
                          variant="outlined"
                          onClick={() => setShowUserDetails(index + 'hide')}
                          data-testid="less-details"
                        >
                          Less Details
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ p: 2 }}>
                        <Typography
                          sx={{
                            fontSize: 16,
                            fontWeight: 600,
                            color: '#171D40',
                            textTransform: 'capitalize'
                          }}
                        >
                          {row?.name}
                        </Typography>
                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#6F6F6F' }}>
                          Email - {row?.email}
                        </Typography>

                        <Button
                          sx={{ mt: 2, position: 'absolute', bottom: '10px' }}
                          size="small"
                          variant="outlined"
                          onClick={() => setShowUserDetails(index + 'show')}
                          data-testid="more-details"
                        >
                          More Details
                        </Button>
                      </Box>
                    )}
                  </Card>
                </Grid>
              ))}
              {loading && (
                <Box
                  sx={{
                    flex: 1, // <-- fills the card vertically
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  data-testid="loader_circular_progress"
                >
                  <CircularProgress size={30} sx={{ color: 'black' }} />
                </Box>
              )}
              {organizationUsers?.length === 0 && loading !== true && <NoDataAvailable />}
            </Grid>
            <Divider sx={{ m: 0 }} />

            <CustomPagination
              page={page}
              handleNextPage={() => handleChangePage('NEXT')}
              handlePreviousPage={handleChangePage}
              hasNextPage={isHasTransactionDataHasNextPage}
              data={organizationUsers}
              setPage={setPage}
            />
          </>
        )}
      </Container>

      <ConfirmDialog
        open={openConfirm}
        message={dialogConfig.message}
        onCancel={dialogConfig.onCancel}
        onConfirm={dialogConfig.onConfirm}
        loading={dialogConfig?.loading}
        note={dialogConfig?.note}
        confirmText={dialogConfig?.confirmText}
        cancelText={dialogConfig?.cancelText}
      />
      <SnackBarAlert
        open={isSnackBarAlertOpen}
        title={snackBarMetas?.title}
        message={snackBarMetas?.message}
        severity={snackBarMetas?.severity}
        handleClose={() => setIsSnackBarAlertOpen(false)}
      />
      {isCheckerMakerRequired === 'YES' && (
        <AddUserToNoxModal
          opneAssignedModal={isAddUserToNoxModalOpen}
          handleClose={() => {
            setIsAddUserToNoxModalOpen(false);
            setSelectedUser({});
          }}
          headOfficesList={headOfficesList}
          zonesList={zonesList}
          regionsList={regionsList}
          branchesList={branchesList}
          fetchRegions={(headOfficeId, zoneOfficeId) => fetchRegionList(headOfficeId, zoneOfficeId)}
          fetchZones={(headOfficeId) => fetchZonesList(headOfficeId)}
          fetchBranchesList={(regionalOfficeId) =>
            fetchBranchesList(regionalOfficeId)
          }
          selectedUser={selectedUser}
          onAction={() => onAction()}
        />
      )}
      {isCheckerMakerRequired !== 'YES' && (
        <AddUserToOrganizationModal
          opneAssignedModal={isAddUserToNoxModalOpen}
          handleClose={() => {
            setIsAddUserToNoxModalOpen(false);
            setSelectedUser({});
          }}
          selectedUser={selectedUser}
          onAction={() => onAction()}
          headOfficesList={headOfficesList}
        />
      )}
    </Page>
  );
}
